import "./scss/style.scss";
import Alpine from "alpinejs";
import DownloadJS from "downloadjs";
import ScrollMagic from "scrollmagic";
import Header from "./js/template-parts/common/header";
import ModulesLoader from "./js/modules-loader";
import Barba from "./js/lib/barba";
import Cookies from "./js/template-parts/popups/cookies";
import DisableScroll from "./js/lib/disable-scroll";
import ScriptsLoaded from "./js/lib/scripts-loaded";
import StylesLoaded from "./js/lib/styles-loaded";

window.updateHighlightMenu = () => {
	// DESKTOP
	var header_desktop = document.querySelector('#header-desktop');
	if (header_desktop) {
		try {
			var current_link_desktop = header_desktop.querySelector('a[href="'+window.location+'"][id]');	
		} catch {
			// Si no existe la pagina en el menu
			header_desktop.querySelectorAll('a').forEach((e) => {
				e.classList.remove('current-menu-item');
			});
		}
		
		
		if (current_link_desktop) {
			header_desktop.querySelectorAll('a').forEach((e) => {
				e.classList.remove('current-menu-item');
			});
			current_link_desktop.classList.add('current-menu-item');
			
			// First Parent
			var parent_id = current_link_desktop.getAttribute('data-id-parent');
			if (parent_id) {
				var first_parent = header_desktop.querySelector('a[id="menu-item-'+parent_id+'"]');
				first_parent.classList.add('current-menu-item');	
			
				// Second Parent	
				var second_parent_id = first_parent.getAttribute('data-id-parent');
				if (second_parent_id) {
					var second_parent = header_desktop.querySelector('a[id="menu-item-'+second_parent_id+'"]');
					second_parent.classList.add('current-menu-item');
				}
			}	
		}
	}
	
	// MOBILE
	var header_mobile = document.querySelector('#header-mobile .header-mobile__menu_new');
	if (header_mobile) {
		try {
			var current_link_mobile = header_mobile.querySelector('a[id][href="'+window.location+'"]')?? header_mobile.querySelector('div[onclick="window.location = \''+window.location+'\';"]').closest('a');	
		} catch {
			// Si no existe la pagina en el menu
			header_desktop.querySelectorAll('a').forEach((e) => {
				e.classList.remove('current-menu-item');
			});
		}
		
		
		if (current_link_mobile) {
			header_mobile.querySelectorAll('a').forEach((e) => {
				e.classList.remove('current-menu-item');
			});
			current_link_mobile.classList.add('current-menu-item');	
			
			// First Parent
			parent_id = current_link_mobile.getAttribute('data-id-parent');
			if (parent_id) {
				first_parent = header_mobile.querySelector('a[id="menu-item-resp-'+parent_id+'"]');
				first_parent.classList.add('current-menu-item');	
			
				// Second Parent	
				second_parent_id = first_parent.getAttribute('data-id-parent');
				if (second_parent_id) {
					second_parent = header_mobile.querySelector('a[id="menu-item-resp-'+second_parent_id+'"]');
					second_parent.classList.add('current-menu-item');
				}
			}	
		}
	}
};

// Change color for the current menu links
window.addEventListener("load", function (event) {
	window.updateHighlightMenu();
});

window.initializedScripts = ScriptsLoaded();
window.initializedStyles = StylesLoaded();
// AlpineJS
window.Alpine = Alpine;
Alpine.start();
// DownloadJS (to allow download .ics files with javascript).
window.DownloadJS = DownloadJS;
// Header
window.header = Header();

window.ScrollMagic = ScrollMagic;

window.barba = new Barba();



window.addEventListener("load", () => {
	// Ajax requests
	window.ajaxReq = function ajaxReq() {
		if (window.XMLHttpRequest) {
			return new XMLHttpRequest(); // eslint-disable-line
		}

		if (window.ActiveXObject) {
			return new ActiveXObject("Microsoft.XMLHTTP"); // eslint-disable-line no-console
		}

		console.log("Browser does not support XMLHTTP."); // eslint-disable-line no-console
		return false;
	};


	/*	//fadein fadeout functions
		function fadeIn(element) {
			let opacity = 0;
			element.style.opacity = 0;
			element.style.display = 'block'; // Ensure element is visible

			const timer = setInterval(() => {
				opacity += 0.1;
				element.style.opacity = opacity;

				if (opacity >= 1) {
					clearInterval(timer);
				}
			}, 40); // Adjust the interval (in milliseconds) for fade speed
		}

		function fadeOut(element) {
			let opacity = 1;
			const timer = setInterval(() => {
				opacity -= 0.1;
				element.style.opacity = opacity;

				if (opacity <= 0) {
					clearInterval(timer);
					element.style.display = 'none'; // Hide after fading out
				}
			}, 1); // Adjust the interval for fade speed
		}
		//Hover effects menu
		const categorySelectors = document.querySelectorAll('.category-selector');
		const submenulinks1 = document.querySelectorAll('.sub-menu__container__2 .sub-menu__container__links')
		const submenulinks1list = document.querySelectorAll('.sub-menu__container__2 .sub-menu__container__links .link-item')
		const submenulinks2 = document.querySelectorAll('.sub-menu__container__3 .sub-menu__container__links')
		submenulinks1.forEach(item => fadeOut(item))
		submenulinks2.forEach(item => fadeOut(item))

		categorySelectors.forEach(selector => {
			selector.addEventListener('mouseover', () => {
				const targetSubmenuId = selector.dataset.id;

				// Fade out non-matching submenus
				submenulinks1.forEach(item => {
					if (item.dataset.id !== targetSubmenuId) {
						fadeOut(item);
					}
				});

				// Fade in the target submenu
				setTimeout(() => {
					fadeIn(document.querySelector(`.sub-menu__container__2 .sub-menu__container__links[data-id="${targetSubmenuId}"]`));
				}, 250)
			});
		});

		submenulinks1list.forEach(selector => {
			selector.addEventListener('mouseover', () => {
				const targetSubmenuId = selector.dataset.id;

				// Fade out non-matching submenus
				submenulinks2.forEach(item => {
					if (item.dataset.id !== targetSubmenuId) {
						fadeOut(item);
					}
				});

				// Fade in the target submenu
				setTimeout(() => {
					fadeIn(document.querySelector(`.sub-menu__container__3 .sub-menu__container__links[data-id="${targetSubmenuId}"]`));
				}, 250)

			});
		})
	*/

	function fadeIn(element) {
		element.style.opacity = 0;
		element.style.display = 'block';

		// Use requestAnimationFrame for smoother animations
		let lastTime = 0;
		const duration = 300; // Animation duration in milliseconds

		function animate(currentTime) {
			const elapsed = currentTime - lastTime;
			lastTime = currentTime;

			let progress = elapsed / duration;
			if (progress > 1) progress = 1;

			element.style.opacity = progress;

			if (progress < 1) {
				requestAnimationFrame(animate);
			}
		}

		requestAnimationFrame(animate);
	}

	function fadeOut(element) {
		let opacity = 1;
		const duration = 10; // Animation duration in milliseconds
		let lastTime = 0;

		function animate(currentTime) {
			const elapsed = currentTime - lastTime;
			lastTime = currentTime;

			let progress = 1 - (elapsed / duration);
			if (progress < 0) progress = 0;

			element.style.opacity = progress;

			if (progress > 0) {
				requestAnimationFrame(animate);
			}
			else {
				element.style.display = 'none';
			}
		}

		requestAnimationFrame(animate);
	}
	
	function fadeOutOpacity(element) {
		if (!element)
			return
		
		let opacity = 1;
		const duration = 10; // Animation duration in milliseconds
		let lastTime = 0;

		function animate(currentTime) {
			const elapsed = currentTime - lastTime;
			lastTime = currentTime;

			let progress = 1 - (elapsed / duration);
			if (progress < 0) progress = 0;

			element.style.opacity = progress;

			if (progress > 0) {
				requestAnimationFrame(animate);
			}
		}

		requestAnimationFrame(animate);
	}

	// Example usage (assuming the same HTML structure as before):
	const categorySelectors = document.querySelectorAll('.category-selector');
	const submenulinks1 = document.querySelectorAll('.sub-menu__container__2 .sub-menu__container__links');
	const submenulinks1list = document.querySelectorAll('.sub-menu__container__2 .sub-menu__container__links .link-item');
	const submenulinks2 = document.querySelectorAll('.sub-menu__container__3 .sub-menu__container__links');
	const submenu3 = document.querySelector('.sub-menu__container__3');

	submenulinks1.forEach(item => fadeOut(item));
	submenulinks2.forEach(item => fadeOut(item));
	fadeOutOpacity(submenu3)

	categorySelectors.forEach(selector => {
		selector.addEventListener('mouseover', () => {
			const targetSubmenuId = selector.dataset.id;
			submenulinks2.forEach(item => {
				fadeOut(item);
			});
			fadeOutOpacity(submenu3)
			// Fade out non-matching submenus
			submenulinks1.forEach(item => {
				if (item.dataset.id !== targetSubmenuId) {
					fadeOut(item);
				}
			});

			// Fade in the target submenu
			let targetElement = document.querySelector(`.sub-menu__container__2 .sub-menu__container__links[data-id="${targetSubmenuId}"]`)
			if (targetElement)
				fadeIn(targetElement);

		});
	});

	submenulinks1list.forEach(selector => {
		selector.addEventListener('mouseover', () => {
			const targetSubmenuId = selector.dataset.id;
			// Fade out non-matching submenus
			submenulinks2.forEach(item => {
				if (item.dataset.id !== targetSubmenuId) {
					fadeOut(item);
				}
			});

			// Fade in the target submenu

			let targetElement = document.querySelector(`.sub-menu__container__3 .sub-menu__container__links[data-id="${targetSubmenuId}"]`);

			if (targetElement)
				fadeIn(submenu3)
				fadeIn(targetElement);
		});

	});


	// Muestra guias
	
	//guias de maquetación
	const $guides = document.getElementById('guides');
	if ($guides) {
		const guidesSwitcher = () => {
			const $guidesSwitcher = $guides.querySelector('.guides__switcher');
			const $guidesHr = $guides.querySelector('.guides__horizontal');

			$guidesSwitcher.addEventListener("click", function () { 
				if($guidesHr.style.display === 'block')
				{
					gsap.set($guidesHr, { display: 'none' });
				}
				else
				{
					gsap.set($guidesHr, { display: 'block' });
				}
				});
		};

		guidesSwitcher();
	}

	// Set animations
	window.setAnimationScenes = function setAnimationScenes(
		scrollMagicController
	) {
		const animatableElements = [
			".alliances",
			".conversion",
			".featured-content",
			".hero",
			".featured-text",
			".featured-content-text",
			".banner-image",
			".list-links",
			".text-content",
			".cards-slider",
			".slider-gallery",
			".table",
			".table__container",
			".not-found",
			".posts-grid",
			".post-card",
			".rankings",
			".team",
			".numbers",
			".post-pagination",
			".locations",
		];
		// Set animation classes to all the elements that will use them.
		/* eslint-disable no-restricted-syntax */
		window.scenes = [];
		for (const el of Array.from(
				document.querySelectorAll(animatableElements.join(","))
			)) {
			window.scenes.push(
				new ScrollMagic.Scene({
					triggerElement: el,
					triggerHook: 0.75,
					reverse: false,
				})
				.setClassToggle(el, "animated")
				.addTo(scrollMagicController)
			);
		}
		/* eslint-enable no-restricted-syntax */
	};

	// Load JS scripts
	window.loadJS = function loadJS(file, callback) {
		// DOM: Create the script element
		const jsElm = document.createElement("script");
		// set the type attribute
		jsElm.type = "application/javascript";
		// make the script element load file
		jsElm.src = file;
		// add a callback
		jsElm.addEventListener("load", callback);
		// finally insert the element to the body element in order to load the script
		document.body.appendChild(jsElm);
	};

	// Modules loader
	window.modulesLoader = new ModulesLoader();
	window.modulesLoader.loadModules();

	// Disable scroll
	window.disableScroll = new DisableScroll();

	// Cookies banner
	window.cookies = new Cookies();

	window.scrollMagicController = new ScrollMagic.Controller();
	// Animations
	window.setAnimationScenes(window.scrollMagicController);
});
